import { Box, MenuItem } from "@mui/material";
import { useState } from "react";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { ContextMenuAction } from "../../../../types/contextMenuAction";
import StyledMenuButton from "./StyledMenuButton";
import { ActionBarStyledMenu } from "./ActionBarStyledMenu";

interface AssignActionButtonProps {
  assignActions: ContextMenuAction[];
  /** If provided, this will be called instead of opening the menu */
  onAssignTrigger?: () => void;
}

export default function AssignActionButton({
  assignActions,
  onAssignTrigger,
}: AssignActionButtonProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const individualAssignAction = assignActions[0];

  // Wraps the single‐action click
  const handleSingleClick = () => {
    if (onAssignTrigger) {
      onAssignTrigger();
    } else if (individualAssignAction.handleClick) {
      // pass a fake event so TS is happy
      individualAssignAction.handleClick({} as React.MouseEvent);
    }
  };

  // Wraps the multi‐action click (opens dropdown)
  const handleMultiClick = (e: React.MouseEvent<HTMLElement>) => {
    if (onAssignTrigger) {
      onAssignTrigger();
    } else {
      setAnchorEl(e.currentTarget);
    }
  };

  return (
    <Box display="flex">
      {assignActions.length === 1 ? (
        <StyledMenuButton
          startIcon={individualAssignAction.icon}
          onClick={handleSingleClick}
        >
          {individualAssignAction.label}
        </StyledMenuButton>
      ) : (
        <>
          <StyledMenuButton
            startIcon={<AssignmentIcon />}
            showExpandIcon
            onClick={handleMultiClick}
          >
            Assign
          </StyledMenuButton>
          <ActionBarStyledMenu
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleClose}
            onClick={handleClose}
          >
            {assignActions.map((action) => (
              <MenuItem key={action.barLabel} onClick={action.handleClick}>
                {action.icon} {action.barLabel}
              </MenuItem>
            ))}
          </ActionBarStyledMenu>
        </>
      )}
    </Box>
  );
}
